import React, { FC } from "react";
import { ResourceTypeContainer, ResourceTypeIcon, ResourceTypes, ResourceTypeTitle } from "./styled";
import { ResourceTypeProps } from "./types";

export const ResourceType: FC<ResourceTypeProps> = ({
  className,
  disabledTypes = [],
  resourceTypes,
  selectedType,
  typeWidth,
  onSelect,
}) => {
  return (
    <ResourceTypes className={className}>
      {resourceTypes.map(resourceType => {
        const { text, icon, value } = resourceType;

        return (
          <ResourceTypeContainer
            key={value}
            width={typeWidth}
            disabled={disabledTypes.includes(value)}
            selected={selectedType === value}
            onClick={() => onSelect(resourceType)}
          >
            <ResourceTypeIcon primary={selectedType === value} kind={icon} />
            <ResourceTypeTitle>{text}</ResourceTypeTitle>
          </ResourceTypeContainer>
        );
      })}
    </ResourceTypes>
  );
};
